import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { KollelFormData } from '../schemas/kollelFormSchema';
import Input from '@/components/ui/Input';

/** Step 1 of 4 — "פרטי כולל": name, address, and the two contacts (Rosh Kollel + supervising body). */
const KollelDetailsStep = () => {
  const { t } = useTranslation();
  const { register, formState: { errors } } = useFormContext<KollelFormData>();

  return (
    <div className="w-full flex flex-col gap-6">
      <h3 className="heading-h3-semibold text-(--font-primary)">{t('kollels.wizard.step1.title')}</h3>

      <div className="grid grid-cols-2 max-md:grid-cols-1 gap-4">
        <label className="flex flex-col gap-1">
          <span className="body-md-semibold text-(--font-secondary)">{t('kollels.form.nameLabel')}</span>
          <Input placeholder={t('kollels.form.namePlaceholder')} {...register('name')} />
          {errors.name && <p className="text-red-500 body-sm-regular">{errors.name.message}</p>}
        </label>
        <label className="flex flex-col gap-1">
          <span className="body-md-semibold text-(--font-secondary)">{t('kollels.form.addressLabel')}</span>
          <Input placeholder={t('kollels.form.addressPlaceholder')} {...register('address')} />
        </label>
      </div>

      {(
        [
          ['roshKollelContact', 'roshKollelTitle'] as const,
          ['supervisingBodyContact', 'supervisingBodyTitle'] as const,
        ]
      ).map(([field, titleKey]) => (
        <fieldset key={field} className="flex flex-col gap-2 border border-(--border-main) rounded-lg p-4">
          <legend className="body-lr-semibold text-(--font-primary) px-1">{t(`kollels.form.${titleKey}`)}</legend>
          <div className="grid grid-cols-3 max-md:grid-cols-1 gap-3">
            <label className="flex flex-col gap-1">
              <span className="body-xs-regular text-(--font-secondary)">{t('kollels.form.contactNameLabel')}</span>
              <Input placeholder={t('kollels.form.contactNamePlaceholder')} {...register(`${field}.name`)} />
            </label>
            <label className="flex flex-col gap-1">
              <span className="body-xs-regular text-(--font-secondary)">{t('kollels.form.emailLabel')}</span>
              <Input type="email" {...register(`${field}.email`)} />
            </label>
            <label className="flex flex-col gap-1">
              <span className="body-xs-regular text-(--font-secondary)">{t('kollels.form.phoneLabel')}</span>
              <Input type="tel" {...register(`${field}.phone`)} />
            </label>
          </div>
        </fieldset>
      ))}
    </div>
  );
};

export default KollelDetailsStep;
